import { Calendar } from '@powerportalspro/react-calendar';

// Every sample appointment, not only one account's, so a weekday is full.
export function CalendarDayLayoutSample() {
  return <Calendar defaultLayout="day" defaultTables={['appointment']} height="640px" />;
}
